export const notificationsTranslations = {
  title: 'Notifications',
  pageTitle: 'Notifications', 
  pageDescription: 'View and manage your notifications',
  settingsTitle: 'Notification Settings',
  settingsPageTitle: 'Notification Settings',
  settingsPageDescription: 'Manage your notification preferences',
  settings: 'Settings',
  markAsRead: 'Mark as read',
  markAllAsRead: 'Mark all as read',
  delete: 'Delete',
  more: 'more',
  noNotifications: 'No notifications',
  emptyDescription: "You don't have any notifications yet",
  errorLoading: 'Error loading notifications',
  errorLoadingSettings: 'Error loading notification settings',
  tryAgain: 'Please try again later',
  enableNotifications: 'Enable Notifications',
  enablePromptMessage:
    'Stay updated with the latest reviews, likes, and follows by enabling notifications.',
  remindLater: 'Remind me later',
  enable: 'Enable',
  stayUpdated: 'Stay Updated',
  enableDescription:
    'Enable notifications to stay informed about new reviews, likes, and follows.',
  pushNotifications: 'Push Notifications',
  pushDescription: 'Receive notifications on your device',
  emailNotifications: 'Email Notifications',
  emailDescription: 'Receive notifications via email',
  enableAllNotifications: 'Enable All Notifications',
  masterToggleDescription: 'Turn on/off all notifications',
  notificationTypes: 'Notification Types',
  types: {
    reviewLiked: 'Review Liked',
    reviewLikedDescription: 'Get notified when someone likes your review',
    newPlaceReviews: 'New Place Reviews',
    newPlaceReviewsDescription: 'Get notified when a new place is reviewed',
    newFoodReviews: 'New Food Reviews', 
    newFoodReviewsDescription: 'Get notified when a new food is reviewed',
    newReviewCreated: 'New Review Created',
    newReviewCreatedDescription: 'Get notified when a new review is created',
    userFollowed: 'User Followed',
    userFollowedDescription: 'Get notified when a user follows you',
  },
};
export type NotificationsTranslations = typeof notificationsTranslations;

export default notificationsTranslations;
